import { render } from "./SlideUp.vue?vue&type=template&id=6f956ea1&scoped=true"
import script from "./SlideUp.vue?vue&type=script&lang=js"
export * from "./SlideUp.vue?vue&type=script&lang=js"

import "./SlideUp.vue?vue&type=style&index=0&id=6f956ea1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f956ea1"]])

export default __exports__